import { Component, OnInit } from '@angular/core';
import { FileService } from '@shared/services/file.service';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {

  constructor(private fileService: FileService) {
  }

  ngOnInit(): void {
  }

  cancel() {

  }

  download() {
    // const data: any = document.getElementById('htmlData');
    // const fileName = 'test-report';
    // this.fileService.pdf(data, fileName);
  }
}
